import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IEstadoEntidad, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { ConfigEventoUsuarioService } from '../../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { IRegExpSearch } from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { CrearEditarEstadoCuentaComponent } from '../crear-editar-estado-cuenta/crear-editar-estado-cuenta.component';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-estado-entidad',
  templateUrl: './listado.component.html',
})
export class ListadoEstadoEntidadsComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ConfigEventoUsuarioService);
  private formularios = inject(FormularioDialogService);

  //// Tabla nueva
  public name = 'ListadoEstadoEntidadsComponent';
  public estadoEntidads?: IEstadoEntidad[];
  public estadoEntidads$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEstadoEntidad>[];
  public search: IRegExpSearch = {
    fields: ['estado'],
  };
  // FILTROS

  public filter: IFilter<IEstadoEntidad> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'usuario',
      select: 'usuario datosPersonales.nombre',
    },
    {
      path: 'alarma',
      select: 'nombre',
    },
    {
      path: 'tracker',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    let filter: IFilter<IEstadoEntidad> = {};
    if (this.query.filter) {
      filter = JSON.parse(this.query.filter);
    }
    this.query.filter = JSON.stringify(filter);
    //
    this.estadoEntidads$?.unsubscribe();
    this.estadoEntidads$ = this.lista2
      .estadoEntidads(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.estadoEntidads = data.datos;
      });
  }

  public async editar(estado: IEstadoEntidad) {
    const res = this.formularios.abrir(CrearEditarEstadoCuentaComponent, {
      tamano: 'chico',
      data: { estadoEntidad: estado },
    });
    if (res) {
      await this.listar();
    }
  }

  public async eliminar(estado: IEstadoEntidad) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar el estado?`,
    );
    if (!res) return;
    try {
      await this.service.delete(estado._id!);
      this.helper.notifSuccess('Estado eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const cols: IColumnas<IEstadoEntidad>[] = [
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
        },
      },
      {
        header: {
          label: 'Estado',
          sortable: true,
          sort: 'estado',
        },
        row: {
          estado: (dato) => {
            switch (dato.estado) {
              case undefined:
                return undefined;
              case 'Habilitado':
                return { texto: 'Habilitado', tono: 'ok', icono: 'toggle_on' };
              case 'Suspendido':
                return { texto: 'Suspendido', tono: 'error', icono: 'block' };
              default:
                return { texto: dato.estado, tono: 'neutro' };
            }
          },
          noData: 'Sin estado',
        },
      },
      {
        header: {
          label: 'Nota',
          sortable: true,
        },
        row: {
          field: 'nota',
          noData: 'Sin nota',
        },
      },
      {
        header: {
          label: 'Motivos',
        },
        row: {
          lista(dato) {
            return dato.motivos ?? [];
          },
          noData: 'Sin motivos',
        },
      },
      {
        header: {
          label: 'Usuario',
        },
        row: {
          parse(dato) {
            return (
              dato?.usuario?.datosPersonales?.nombre || dato.usuario?.usuario
            );
          },
          noData: 'Sin usuario',
        },
      },
    ];

    // Entidad
    cols.push({
      header: {
        label: 'Entidad',
      },
      row: {
        parse(dato) {
          return dato?.alarma?.nombre || dato?.tracker?.nombre;
        },
        noData: 'Sin entidad',
      },
    });
    // Acciones
    // cols.push({
    //   header: {
    //     label: 'Acciones',
    //   },
    //   row: {
    //     acciones: [
    //       {
    //         tipo: 'material',
    //         color: 'primary',
    //         icon: 'edit',
    //         tooltip: 'Editar',
    //         click: (dato) => this.editar(dato),
    //       },
    //       {
    //         tipo: 'material',
    //         color: 'warn',
    //         icon: 'delete',
    //         tooltip: 'Eliminar',
    //         click: (dato) => this.eliminar(dato),
    //         disabled() {
    //           return LoginService.getUsuario()?._id === 'admin';
    //         },
    //       },
    //     ],
    //   },
    // });
    this.columnas = cols;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    Promise.all([this.listar()]);
  }

  async ngOnDestroy() {
    this.estadoEntidads$?.unsubscribe();
  }
}
